import { defineStore } from 'pinia';
import { ChecklistNotifiableEditable } from '@/ui/DTO';

interface State {
  notifiables: Array<ChecklistNotifiableEditable>;
}

export const useChecklistNotifiablesStore = defineStore('checklistNotifiables', {
  state: (): State => ({
    notifiables: [],
  }),
  actions: {
    setNotifiables(notifiables: Array<ChecklistNotifiableEditable>) {
      this.notifiables = notifiables;
    },

    addNotifiable(notifiable: ChecklistNotifiableEditable) {
      this.notifiables.push(notifiable);
    },

    removeNotifiable(notifiable: ChecklistNotifiableEditable) {
      this.notifiables = this.notifiables.filter(n => n !== notifiable);
    },
  },
});
